import { LandingPageUser, UserRoles } from 'common/types'
import { useNotification } from 'hooks/use-notification/useNotification'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useState, useLayoutEffect, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useUserApi } from 'hooks/use-user-api/useUserApi'
import { useLocalStorage } from 'hooks/use-local-storage/useLocalStorage'

export const useLandingPage = (admin?: string, pathname?: string) => {
    const { notify } = useNotification()
    const { setItem } = useLocalStorage()
    const { getUserWithEmail, fetchUser } = useUserApi()
    const [showModal, setShowModal] = useState(false)
    const [showAdmin, setShowAdmin] = useState(false)
    const [title, setTitle] = useState('')
    const [tabIndex, setTabIndex] = useState(pathname === '/register' ? 1 : 0)
    const [roleType, setRoleType] = useState<UserRoles>(pathname?.includes('partner') ? UserRoles.Partner : UserRoles.Member)
    const [isLocked, setIsLocked] = useState(false)
    const [userId, setUserId] = useState<string>()
    const location = useLocation()

    const {
        loginUsingUsernameAndPassword,
        loginUsingSSO,
        signUpUsingUsernameAndPassword,
        username,
        password,
        setUsername,
        setPassword,
        onPasswordReset,
        setUser,
    } = useAuth()

    const memberTitle: string[] = ['SIGN IN', 'SIGN UP']

    useLayoutEffect(() => {
        setShowAdmin(admin === 'admin' ? true : false)
        setTitle(memberTitle[tabIndex || 0])

    }, [admin, tabIndex])

    useEffect(() => {
        const packageType = new URLSearchParams(location?.search).get('partnerType')?.replace("_", " ")
        const community = new URLSearchParams(location?.search).get('community')
        if (community == 'true' || typeof packageType == 'string') {
            setItem('partnerconfig', JSON.stringify({packageType, community}))
        }
    }, [])

    const onSubmit = async (action: 'signIn' | 'signUp' | 'passwordReset', role: UserRoles, email?: string) => {
        switch (action) {
            case 'signIn': {
                await loginUsingUsernameAndPassword(role)
                return
            }
            case 'signUp': {
                const userResponse = await signUpUsingUsernameAndPassword(role)
                setUser(userResponse)
                break

            }
            case 'passwordReset': {
                await onPasswordReset(email)
                notify('success', 'Please check your email to reset your password')
                return
            }
        }
    }



    const registeredUser = async (email: string) => {
        const user: LandingPageUser = await getUserWithEmail(email)
        return user
    }

    const handleUsernameChange = async (value: string) => {
        setUsername(value)

        const user = await registeredUser(value)
        if(!user) return

        if(user?.userExists && user?.isEnabled){
            notify('success', `User ${value}  already exist. Please Login`)
            setUsername('')
            setPassword('')
            return
        }

        if(user?.userExists && !user.isEnabled){
            setIsLocked(true)
            const fetchedUser = await fetchUser(user?.userId)
            setUser(fetchedUser)
            setUserId(user?.userId)
        }
    }
    return {
        showModal,
        title,
        tabIndex,
        onSubmit,
        setTabIndex,
        roleType,
        username,
        password,
        setUsername,
        setPassword,
        loginUsingSSO,
        showAdmin,
        setShowAdmin,
        handleUsernameChange,
        isLocked,
        setIsLocked,
        userId
    } as const
}
